<template>
  <span class="space-x-2">
    <span
      v-for="(item, itemIndex) in formula"
      :key="JSON.stringify(item) + itemIndex"
    >
      <span v-if="Array.isArray(item)" class="space-x-2">
        <span data-cy="parenthesis">(</span>
        <custom-attribute-preview-formula :formula="item" />
        <span data-cy="parenthesis">)</span>
      </span>
      <template
        v-else-if="typeof item === 'string' || typeof item === 'number'"
      >
        <span data-cy="formulaItem">{{ item }}</span>
      </template>
      <custom-attribute-preview-formula-item
        v-else-if="typeof item === 'object'"
        data-cy="formulaAttributeItem"
        :item="item"
      />
    </span>
  </span>
</template>
<script setup lang="ts">
import CustomAttributePreviewFormulaItem from "@/views/profile/components/dataOrchestration/configPanel/customAttributes/CustomAttributePreviewFormulaItem.vue";

import type { CustomAttributeFormula } from "@/models/customAttributes/customAttribute";

defineProps<{
  formula: CustomAttributeFormula;
}>();
</script>
